import { atom } from "recoil";
import { ProfileProps } from "src/models/common.model";

export const adminProfileState = atom<ProfileProps>({
  key: "adminProfileState",
  default: {
    uuid: "",
    username: "",
    email: "",
    name: "",
    phone_number: "",
    admin_id: "",
    type: "",
  },
});
